import { addSearchParamToUrl } from '@dte/otw-azure-functions/src/common/util/network/url/addSearchParamsToUrl';
import { validateOptionalPremiseId } from '@dte/otw-azure-functions/src/common/util/validation/validatePremiseId';
import { v4 } from 'uuid';
import { ReportStep } from '../ReportSteps';
import { getReportStepPath } from '../useDraftPath';

export function getReportProblemLink(premiseId?: string): string {
	let firstStep = ReportStep.NonPremise;

	const premiseIdValue = validateOptionalPremiseId(premiseId);
	if (premiseIdValue) {
		firstStep = ReportStep.Reporter;
	}
	let reportLink = getReportStepPath(firstStep);
	reportLink = addSearchParamToUrl(reportLink, 'premiseId', premiseIdValue);
	// Pass in a fresh UUID
	reportLink = addSearchParamToUrl(reportLink, 'reportId', v4());
	return reportLink;
}
